import React, { createContext, useEffect, useState } from "react"
import Constantes from "../constantes/Constantes";
export const AppContext = createContext(null);


export const ContextWrapper = props => {
  const { PATH_API } = Constantes;
 
  // manejamos el update de la pagina
  useEffect(() => {
    // leemos los ids guardados en el storage
    const idsFromStorage = JSON.parse(localStorage.getItem('ids')) || [];
  
    try{
      fetch(`${PATH_API + 'rollback_status_product'}`, {
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          ids: JSON.stringify(idsFromStorage),
        }
      }).then((response) => {
        if(response.status == 200){
          // limpiamos el storage
          localStorage.clear();
        } else {
          window.alert('No fue posible realizar el proceso');
        }
      }).catch((error) => {});
    } catch(error){
      window.alert(`catch error : No fue posible realizar el proceso ${error}`);
    }
  }, []);

  // metodo para guardar los ids de los productos en el storage
  const addItemsStorage = ( id ) => {
    let storedIds = JSON.parse(localStorage.getItem('ids')) || [];
    if(!storedIds.includes(id)){
        storedIds.push(id);
        // Actualizar el arreglo en el localStorage
        localStorage.setItem('ids', JSON.stringify(storedIds));
    }
  }
 
  const [store, setStore] = useState({
    productos: {},
    usuarioAuntenticado: { nombre: "" },
    envio: 0,
    carrito: {},
    tipoProductoSeleccionado: {
      idTipoProducto: 0,
      descripcion: "Selecciona un tipo de producto",
    },
    aprobacion: "",
    primeraVista: true,
    codigoDescuento: "",
    porcentajeDescuento: 0.0,
  });

  const [tipoEntrega, setTipoEntrega] = useState(null)
  const [cambiarPaso, setCambiarPaso] = useState(1)
  const [alerta, setAlerta] = useState(false)
  const [idCategoria, setIdCategoria] = useState(0)
  const [mostrarOfertas, setMostrarOfertas] = useState(false)
  const [formEntrega, setFormEntrega] = useState({
    name: "",
    lastname: "",
    nit: "",
    email: "",
    tel: "",
    direccion: "",
    departamento: null,
    municipio: null,
    opcionNitDpi: 0,
    dpiPersonaRecoge: "",
    departamentoEntrega: null,
    municipioEntrega: null,
    direccionFacturacion : "",
  })

  const [actions] = useState({
    addTask: ( producto ) => {
      setStore(store => ({
        ...store,
        carrito: {
          ...store.carrito,
          [producto.id]: {
            idProducto: producto.id,
            nombreProducto: `${producto.subcategoria} ${producto.descripcion_marca}`,
            precio: producto.precio,
            urlImg: producto.url,
            sucursal: producto.sucursal,
          },
        },
      }));

      addItemsStorage(producto.id);
    },

    limpiarCarrito: () => {
      setStore(store => ({
        ...store,
        carrito: {},
      }))
    },

    addFormEntrega: form => {
      formEntrega.name = form.name
      formEntrega.lastname = form.lastname
      formEntrega.nit = form.nit
      formEntrega.email = form.email
      formEntrega.tel = form.tel
      formEntrega.direccion = form.direccion
      formEntrega.departamento = form.departamento
      formEntrega.municipio = form.municipio
      formEntrega.opcionNitDpi = form.opcionNitDpi
      formEntrega.dpiPersonaRecoge = form.dpiPersonaRecoge
      formEntrega.departamentoEntrega = form.departamentoEntrega
      formEntrega.municipioEntrega = form.municipioEntrega
      formEntrega.direccionFacturacion = form.direccionFacturacion
    },
    getFormEntrega: () => {
      return formEntrega
    },

    obtenerTotalProductos: carrito => {
      let total = 0
      let arreglo = Object.keys(carrito)
      for (let propiedad of arreglo) {
        total += carrito[propiedad].precio
      }
      return total
    },

    obtenerTotalProductosCarrito: carrito => {
      let arreglo = Object.keys(carrito);
      return arreglo.length;
    },

    obtenerTotalProductosPrueba: (carrito = {}) => {
      let total = 0;
      if(carrito === null) {
        return total;
      } else {
        let arreglo = Object.keys(carrito);
        return arreglo.length;
      }
    },

    obtenerSaludo: (texto = '') =>{
      window.alert(texto);
    },

    addProductos: productos => {
      setStore(store => ({ ...store, productos: productos }))
    },

    eliminarProducto: (carrito, producto) => {
      let carritoNuevo = {}
      Object.keys(carrito).forEach(key => {
        if (carrito[key].idProducto === producto.idProducto) {
        } else carritoNuevo[key] = carrito[key]
      })
      setStore(store => ({
        ...store,
        carrito: carritoNuevo,
      }))

      let total = actions.obtenerTotalProductosCarrito(carritoNuevo)
      if (total === 0) {
        setCambiarPaso(1)
      }
      // se devuelve el estado del producto para que sea visible en la tienda en linea otra ves      
      fetch(`${PATH_API + 'rollback_status_product_by_id'}`, {
        method: 'PUT',
        headers: {
            "Content-Type": "application/json",
            id: producto.idProducto,
        }
      });
    },

    saveTipoEntrega: tipo => {
      setTipoEntrega(tipo)
    },

    obtenerTipoEntrega: () => {
      return tipoEntrega
    },

    cambiarPasoCompras(paso) {
      setCambiarPaso(paso)
    },

    cambiarEstadoAlerta(estado) {
      setAlerta(estado)
    },

    mostrarEstadoAlerta() {
      return alerta
    },

    enviarProductosByIdCategoria(id) {
      setIdCategoria(id);
      setMostrarOfertas(false);
    },

    enviarValorMostrarOfertas( ofera ){
      setMostrarOfertas(ofera)
    },
  })

  return (
    <AppContext.Provider
      value={{
        store,
        actions,
        formEntrega,
        cambiarPaso,
        tipoEntrega,
        alerta,
        idCategoria,
        mostrarOfertas,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
}
